import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FiX, FiInfo, FiCheckCircle, FiAlertCircle, FiAlertTriangle } from 'react-icons/fi';
import './Alert.css';

const Alert = ({ type = 'info', message, dismissible = false, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  const handleDismiss = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };

  const icons = {
    info: <FiInfo />,
    success: <FiCheckCircle />,
    error: <FiAlertCircle />,
    warning: <FiAlertTriangle />
  };

  return (
    <div 
      className={`alert alert--${type}`} 
      role={type === 'error' ? 'alert' : 'status'}
    >
      <span className="alert__icon">{icons[type]}</span>
      <span className="alert__message">{message}</span>
      {dismissible && (
        <button className="alert__close" onClick={handleDismiss} aria-label="Close alert">
          <FiX />
        </button>
      )}
    </div>
  );
};

Alert.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  message: PropTypes.node.isRequired,
  dismissible: PropTypes.bool,
  onClose: PropTypes.func
};

export default Alert;
